var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Form, FormGroup, Label, Input, Button } from 'reactstrap';
import { createErrorResponse, notifyUncaughtErrors } from '../../../utils/errorUtils';
import Page from '../Page';
import { ApplicationContext } from '../../../ApplicationContext';
import FormField from '../../components/ui/FormField/FormField';
import { Link } from 'react-router-dom';
import Routes from '../../../routes/RoutesConfig';
import ForgotPasswordCommand from '../../../commands/authentication/ForgotPasswordCommand';
import Signals from '../../../signals/Signals';
import { FormErrorContext } from '../../../FormErrorContext';
import withRouter from "../../components/ui/MainNavigation/withRouter";
/**
 *
 */
var ForgotPassword = /** @class */ (function (_super) {
    __extends(ForgotPassword, _super);
    /**
     *
     */
    function ForgotPassword(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            errors: null,
            username: undefined,
            submitting: false
        };
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onInputChange = _this.onInputChange.bind(_this);
        _this.onError = _this.onError.bind(_this);
        _this.onSuccess = _this.onSuccess.bind(_this);
        return _this;
    }
    /**
     *
     * @param prevProps
     * @param prevState
     * @param snapshot
     */
    ForgotPassword.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        notifyUncaughtErrors(this.state, this.props.intl);
    };
    /**
     *
     * @returns {*}
     */
    ForgotPassword.prototype.render = function () {
        return (React.createElement(Page, { pageName: "forgot-password", className: "bg-primary" },
            React.createElement("div", { className: "container vh-100 align-items-center" },
                React.createElement("div", { className: "row h-75 justify-content-center align-items-center" },
                    React.createElement("div", { className: "col-md-6 col-lg-4 text-white" },
                        React.createElement("h2", { className: "card-header justify-content-center" },
                            React.createElement(FormattedMessage, { id: "page.forgotpassword.title" })),
                        React.createElement("div", { className: "card-body", style: { fontSize: "large" } },
                            React.createElement(FormErrorContext.Provider, { value: { errors: this.state.errors } },
                                React.createElement(Form, { onSubmit: this.onSubmit },
                                    React.createElement("fieldset", { disabled: this.state.submitting },
                                        React.createElement(FormGroup, null,
                                            React.createElement(FormField, { className: "justify-content-center" },
                                                React.createElement(Label, { for: "email", className: "text-white" },
                                                    React.createElement(FormattedMessage, { id: "page.forgotpassword.field.email" })),
                                                React.createElement(Input, { name: "email", id: "email", type: "email", required: true, onChange: this.onInputChange }))),
                                        React.createElement(Button, { className: "w-100 ml-0 mb-3 font-weight-bolder", color: "dark", type: "submit" },
                                            React.createElement(FormattedMessage, { id: "page.forgotpassword.reset" })),
                                        React.createElement("p", { className: "back-link text-center" },
                                            React.createElement("small", { className: "text-center" },
                                                React.createElement(FormattedMessage, { id: "page.forgotpassword.back" }),
                                                React.createElement(Link, { to: Routes.LOGIN.path, className: "text-white", style: { textDecoration: "underline" } },
                                                    React.createElement(FormattedMessage, { id: "page.forgotpassword.login" })),
                                                ".")))))))))));
    };
    /**
     *
     * @param response
     */
    ForgotPassword.prototype.onSuccess = function (response) {
        var _this = this;
        this.setState({ submitting: false });
        var intl = this.props.intl;
        Signals.ShowAlertModal.dispatch(intl.formatMessage({ id: 'forgotpassword.success.alert.title' }), intl.formatMessage({ id: 'forgotpassword.success.alert.body' }, { email: this.state.email }), intl.formatMessage({ id: 'forgotpassword.success.alert.ok' }), function () { return _this.props.router.navigate(Routes.LOGIN.getPath()); });
    };
    /**
     *
     * @param error
     */
    ForgotPassword.prototype.onError = function (error) {
        console.log(error);
        createErrorResponse(this, error);
    };
    /**
     *
     * @param e
     */
    ForgotPassword.prototype.onSubmit = function (e) {
        e.preventDefault();
        if (this.state.submitting) {
            return;
        }
        this.setState({ errors: null, submitting: true });
        var command = new ForgotPasswordCommand();
        command.execute(this.state.email).then(this.onSuccess).catch(this.onError);
    };
    /**
     *
     * @param e
     */
    ForgotPassword.prototype.onInputChange = function (e) {
        var nextState = {};
        nextState[e.target.name] = e.target.value;
        this.setState(nextState);
    };
    return ForgotPassword;
}(React.Component));
ForgotPassword.contextType = ApplicationContext;
export default injectIntl(withRouter(ForgotPassword));
